<template>
  <div class="form-group bg-light-2 p-4 shadow-lg mt-5">
    <h4>Imágenes del {{ kind }}</h4>
    <small>Se podrán subir 5 imágenes como máximo.</small>
    <hr />
    <p>
      El orden de las imágenes solo se podrá cambiar una vez que se hayan
      guardado las imágenes, es decir, si desea poner una nueva en la posición
      de una de las ya subida, deberá guardar y luego refrescar la página.
    </p>
    <div class="row">
      <div v-for="(image, i) in images" :key="i" class="col-md-3 col-12 mt-3">
        <div
          class="
            image
            img-squared img-thumbnail
            bg-light-2
            d-flex
            justify-content-between
          "
          :style="`background-image: url('${pathImage(image)}');`"
        >
          <div>
            <select
              :id="'selectImagePosition' + (i + 1)"
              :value="i + 1"
              @change="changePositionImages(i + 1)"
            >
              <option
                v-for="j in images.length"
                :key="`opt${i}-${j}`"
                :value="j"
              >
                {{ j == 1 ? "Portada" : `${j}° Imágen` }}
              </option>
            </select>
          </div>
          <span
            class="material-icons text-danger cursor-pointer"
            @click="handleDeleteImage(i)"
            >delete_forever</span
          >
        </div>
      </div>
      <div
        v-for="(urlImage, i) in urlImages"
        :key="'urlimage' + i"
        class="col-md-3 col-12 mt-3 mb-4"
      >
        <div
          class="image img-squared img-thumbnail bg-light-2"
          :class="imageHasUpload ? '' : 'border-success'"
          :style="`background-image: url(${urlImage})`"
        ></div>
      </div>
      <div
        class="col-md-3 col-12 mt-3"
        v-if="images.length + urlImages.length < 5 && !imageHasUpload"
      >
        <input
          type="file"
          class="dragFile"
          multiple
          @change="handleChangeFileImages"
          id="file"
          accept="image/png, image/jpeg"
        />
        <div
          class="
            image
            img-squared img-thumbnail
            bg-light-2
            d-flex
            align-items-center
            border-dots
          "
        >
          <h5 class="text-center">Arrastra imágenes o haz click aquí.</h5>
        </div>
      </div>
      <div class="col-12 mt-4" v-if="!imageHasUpload">
        <span v-if="isUploadImage" class="btn btn-block btn-primary"
          ><span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Subiendo imágenes...</span
        >
        <span v-else class="btn btn-block btn-primary" @click="handleSaveImages"
          >Guardar imágenes</span
        >
      </div>
      <div class="col-12 mt-4" v-if="imageHasUpload">
        <span class="btn btn-block btn-success">imágenes actualizadas</span>
      </div>
    </div>
  </div>
</template>

<script>
import configs from "../../configs/configs";
import Api from "../../tools/Api2";
export default {
  name: "ImagesPublication",
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    kind: {
      type: String,
      default: "producto",
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      url: configs.API.BASE,
      urlImages: [],
      localImages: [],
      imageHasUpload: false,
      isUploadImage: false,
    };
  },
  methods: {
    pathImage(image) {
      return `${this.url}public/images/${
        this.kind == "producto" ? "products" : "services"
      }/${image}`;
    },
    handleChangeFileImages(e) {
      this.urlImages = [];
      this.localImages = e.target.files;
      e.target.files.forEach((file, index) => {
        index < 5 - this.images.length
          ? this.urlImages.push(URL.createObjectURL(file))
          : false;
      });
      this.$emit("handleChangeFileImages", this.localImages)
    },
    handleSaveImages() {
      this.isUploadImage = true;
      Api(this.kind == "producto" ? "product" : "service")
        .useFormData.put(
          this.id,
          {
            urlImages: this.images,
          },
          this.localImages
        )
        .then(() => {
          this.isUploadImage = false;
          this.imageHasUpload = true;
        });
    },
    changePositionImages(i) {
      const newPosition = Number(
        document.querySelector("#selectImagePosition" + i).value
      );
      const imageCache = this.images[newPosition - 1];
      let newOrderImages = [];
      for (let index = 0; index < this.images.length; index++) {
        if (index == i - 1) {
          newOrderImages[index] = imageCache;
        } else if (index == newPosition - 1) {
          newOrderImages[index] = this.images[i - 1];
        } else {
          newOrderImages[index] = this.images[index];
        }
      }
      this.$emit("handleChangeImages", newOrderImages);
    },
    handleDeleteImage(i) {
      this.$emit(
        "handleChangeImages",
        this.images.filter((e, index) => index != i)
      );
    },
  },
};
</script>

<style>
.dragFile {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.border-dots {
  border: 4px dashed rgb(222, 226, 230);
}

.image {
  height: 18em;
  width: 18em;
}
</style>